// VFX: Audio Waveform Bars
// Category: overlays · Tags: waveform, equalizer, audio, podcast, music
// Reactive vertical bar equalizer waveform syncing to audio.
import { AbsoluteFill, useCurrentFrame } from "remotion";
import React from "react";

const BAR_COUNT = 48;

export default function AudioWaveformBarsSyncLoop() {
  const frame = useCurrentFrame();

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(180deg, #0a0e1a 0%, #1e293b 100%)",
      alignItems: "center", justifyContent: "center",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, height: 320 }}>
        {Array.from({ length: BAR_COUNT }).map((_, i) => {
          // simulate audio energy with layered sines
          const a = Math.sin(frame * 0.25 + i * 0.4) * 0.5;
          const b = Math.sin(frame * 0.12 + i * 0.18) * 0.35;
          const c = Math.sin(frame * 0.4 - i * 0.6) * 0.15;
          const energy = Math.abs(a + b + c);
          const h = 30 + energy * 280;
          const hue = 270 - i * 2;
          return (
            <div key={i} style={{
              width: 10, height: h,
              borderRadius: 6,
              background: `linear-gradient(180deg, hsl(${hue},85%,70%) 0%, hsl(${hue + 30},85%,55%) 100%)`,
              boxShadow: `0 0 ${energy * 18}px hsl(${hue},85%,65%)`,
            }} />
          );
        })}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
